var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-agv-login',{attrs:{"default-town":_vm.town,"errors":_vm.errors},on:{"login":_vm.onTryLogin,"requestOneTimeAccess":_vm.onRequestOneTimeAccess,"clickedSignup":_vm.onClickedSignup,"clearError":_vm.onClearLoginError}})}
var staticRenderFns = []

export { render, staticRenderFns }